import { produce } from 'immer'
import type { DesignPersonalizationContext } from '@vp/personalization-types'
import { VistaAsset } from '@design-stack-vista/vista-assets-sdk'
import { DIMENSION_DATA_TIMEOUT_MS, convertVistaAssetToDpcImage } from './converters'
import { RenderableTextField } from '../Schemes/store/types'

const emptyDpc: DesignPersonalizationContext = {
  designPersonalizationContextVersion: 1,
}

export const createNewDpc = async (
  textFields: RenderableTextField[],
  images: { asset: VistaAsset; pageNumber: number }[],
  defaultToPhoto: boolean,
  prevDpc?: DesignPersonalizationContext,
): Promise<DesignPersonalizationContext> => {
  const newDpcImages = await Promise.all(
    images.map(({ asset, pageNumber }) => convertVistaAssetToDpcImage(asset, DIMENSION_DATA_TIMEOUT_MS, defaultToPhoto, pageNumber)),
  )

  return produce(prevDpc || emptyDpc, (draft) => {
    draft.text = draft.text || []
    textFields.forEach(({ purposeName, text }) => {
      const existingField = draft.text?.find((t) => t.textField.purposeName === purposeName)

      if (existingField) {
        if (text) {
          existingField.textField.text = text
        } else {
          draft.text = draft.text?.filter((t) => t.textField.purposeName !== purposeName)
        }
      } else if (text) {
        draft.text?.push({ textField: { purposeName, text } })
      }
    })

    draft.images = newDpcImages

    if (!draft.images.length) {
      delete draft.images
    }

    if (!draft.text.length) {
      delete draft.text
    }
  })
}
